<template>
    <div v-if="protocol != null">
        <protocol-readout-group-list
            v-if="readoutGroups != null"
            :protocol="protocol"
            :readout-groups="readoutGroups"
            @saved="fetchData"
            @deleted="fetchData"
        />
        <protocol-task-group-list
            v-if="taskGroups != null"
            :protocol="protocol"
            :readout-groups="readoutGroups"
            @saved="fetchData"
            @deleted="fetchData"
        />
        <protocol-task-template-list
            v-if="readoutGroups != null && taskGroups != null"
            :task-groups="taskGroups"
            :readout-groups="readoutGroups"
            :protocol="protocol"
        />
    </div>
</template>
<script>
import { defineComponent } from "vue";
import { buildProtocolReadoutGroupsAPI, buildProtocolTaskGroupsAPI } from "@/services/api.services";
import { withLoadingScreen } from "@/lib/loading";
import ProtocolReadoutGroupList from "./ProtocolReadoutGroupList.vue";
import ProtocolTaskGroupList from "./ProtocolTaskGroupList.vue";
import ProtocolTaskTemplateList from "@/components/SchemaConfig/ProtocolTaskTemplateList.vue";
import { thingAPI } from "@/services/things/thingAPI.ts";

export default defineComponent({
    components: { ProtocolTaskGroupList, ProtocolReadoutGroupList, ProtocolTaskTemplateList },

    props: {
        protocolCode: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            protocol: null,
            protocolReadoutGroupsAPI: null,
            readoutGroups: null,
            taskGroups: null,
        };
    },

    async mounted() {
        this.protocolReadoutGroupsAPI = buildProtocolReadoutGroupsAPI(this.protocolCode);
        this.protocolTaskGroupsAPI = buildProtocolTaskGroupsAPI(this.protocolCode);
        await withLoadingScreen(async () => {
            this.protocol = await thingAPI.fetchProtocolByCode(this.protocolCode);
            await this.fetchData();
        });
    },

    methods: {
        async fetchData() {
            await withLoadingScreen(async () => {
                this.readoutGroups = await this.protocolReadoutGroupsAPI.fetchAll();
                this.taskGroups = await this.protocolTaskGroupsAPI.fetchAll();
            });
        },
    },
});
</script>
